import React, { Component } from 'react';
import _ from 'lodash';
import { StyleSheet, css } from 'aphrodite';
import { pulse } from 'react-animations';

import { Flexbox } from './Styles';
import SpinnerBackgroundEn from './images/spinner_en.png';
import SpinnerBackgroundFr from './images/spinner_fr.png';
import Ticker from './images/ticker.png';

import PrimaryButton from './PrimaryButton';

import Locale from './models/Locale';

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    height: 450,
    width: 450,
    marginTop: 30,
    '@media (max-width: 450px)': {
      height: 350,
      width: 350,
    },
    '@media (max-width: 320px)': {
      height: 280,
      width: 280,
    }
  },
  spinnerEn: {
    height: '100%',
    width: '100%',
    backgroundImage: `url(${SpinnerBackgroundEn})`,
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat",
    transform: 'rotate(-28deg)'
  },
  spinnerFr: {
    height: '100%',
    width: '100%',
    backgroundImage: `url(${SpinnerBackgroundFr})`,
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat",
    transform: 'rotate(-28deg)'
  },
  ticker: {
    position: 'absolute',
    top: -35,
    left: 'calc(50% - 18px)',
    height: 49,
    width: 35,
    backgroundImage: `url(${Ticker})`,
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat"
  },
  pulse: {
    animationName: pulse,
    animationDuration: '0.4s',
    animationIterationCount: 5
  }
});

class Spinner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      state: 'unspun',
    };
  }

  render() {
    return(
      <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, Flexbox.fillVertical)} onClick={this.handleClick.bind(this)}>
        <div className={css(styles.container)}>
          <div className={css(Locale.locale() === 'en' && styles.spinnerEn, Locale.locale() === 'fr' && styles.spinnerFr, this.animationStyle())}/>
          <div className={css(styles.ticker, this.tickerAnimationStyle())} />
        </div>
        { this.state.state === 'unspun' &&
          <PrimaryButton>{Locale.localized("Spin The Wheel")}</PrimaryButton>
        }
        { this.state.state === 'spinning' &&
          <PrimaryButton></PrimaryButton>
        }
        { this.state.state === 'spun' &&
          <PrimaryButton>
            {this.state.value === 'action' &&
              <div className={css(styles.pulse)}>{Locale.localized("You spun an action")}</div>
            }
            {this.state.value === 'event' &&
              <div className={css(styles.pulse)}>{Locale.localized("You spun an event")}</div>
            }
            {this.state.value === 'wildcard' &&
              <div className={css(styles.pulse)}>{Locale.localized("You spun chance")}</div>
            }
          </PrimaryButton>
        }
      </div>
    );
  }

  tickerAnimationStyle() {
    if (this.state.state === 'spinning') {
      let animationStyles = StyleSheet.create({
        ticker: {
          animationName: {
            from: { transform: 'rotate(0deg)' },
            to: { transform: 'rotate(-20deg)' }
          },
          animationDuration: '0.075s',
          animationIterationCount: 15,
          animationDirection: 'alternate',
        }
      });
      return animationStyles.ticker;
    } else {
      return false;
    }
  }

  animationStyle() {
    if (this.state.state === 'spinning' || this.state.state === 'spun') {
      let nominalSpin = 4 * 360;
      let spinAngle = nominalSpin + this.state.spinDelta;
      let animationStyles = StyleSheet.create({
        spinner: {
          animationName: {
            from: { transform: 'rotate(-28deg)' },
            to: { transform: `rotate(${spinAngle}deg)` }
          },
          animationDuration: '1.5s',
          animationTimingFunction: 'cubic-bezier(0, 0.3, 0, 1)',
          animationFillMode: 'forwards'
        }
      });
      return animationStyles.spinner;
    } else {
      return false;
    }
  }

  handleClick() {
    if (this.state.state === 'unspun') {
      var value = this.spin();
      var spinDelta = 0; // Need to assign this via state so it doesn't change between renders
      if (value === 'action') {
        spinDelta = _([60, 180, -60]).sample();
      } else if (value === 'event') {
        spinDelta = _([0, -120]).sample();
      } else if (value === 'wildcard') {
        spinDelta = 120;
      }
      this.setState({state: 'spinning', value: value, spinDelta: spinDelta});
      this.props.onSpinStart && this.props.onSpinStart();
      setTimeout(() => {
        this.setState({state: 'spun'});
        setTimeout(() => {
          this.props.onSpinDone(this.state.value);
        }, 1750);
      }, 1800);
    }
  }

  spin() {
    // actionRange starts at 1.0 on turn 0, then decays down to 0.0 by turn 9
    if (Math.random() <= (1.0 - Math.min(this.props.turn * 0.1, 1.0))) {
      return 'action';
    } else if (Math.random() <= 0.9) {
      return 'event';
    } else {
      return 'wildcard';
    }
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/Spinner.js